import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Loading({ label }) {
  const { t } = useTranslation();
  return (
    <div className="loading-box">
      <span className="spinner" aria-hidden="true" />
      {label ?? t('common.loading')}
    </div>
  );
}
